import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  Grid,
  CircularProgress,
  Backdrop,
  Typography,
  useTheme,
  Fab,
  Stack,
  Icon,
  Button,
  AccordionSummary,
  AccordionDetails,
  Accordion,
} from "@mui/material";
import { useSnackbar } from "notistack";
import { GetDiasJefe, AprobarRechazar } from "../../redux/actions/diasjefe";
import { RemMensaje } from "../../redux/actions/mensajes";
import { getCargando, getMensaje, getDiasJefe } from "../../redux/selectors";
import SwiperCard from "../../components/SwipperCard";
import { format as DateFormat } from "date-fns";
import Consulta from "./consulta";

const DiasJefe = () => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const paramIng = useParams();

  const [color, setColor] = React.useState({
    main: theme.palette.background.default,
    pText: theme.palette.text.primary,
    sText: theme.palette.text.secondary,
  });
  const { enqueueSnackbar /*, closeSnackbar*/ } = useSnackbar();
  const backdrop = useSelector((state) => getCargando(state));
  const mensaje = useSelector((state) => getMensaje(state));
  const listado = useSelector((state) => getDiasJefe(state));

  const [sort, setSort] = React.useState(1);
  const [params, setParams] = React.useState(null);
  const [aprobar, setAprobar] = React.useState("");
  const [dia, setDia] = React.useState(null);

  React.useEffect(() => {
    if (mensaje.mensaje !== "") {
      enqueueSnackbar(mensaje.mensaje, {
        preventDuplicate: true,
        anchorOrigin: { vertical: "bottom", horizontal: "center" },
        variant: mensaje.variant,
        autoHideDuration: 3000,
      });
      dispatch(RemMensaje());
    }
  }, [mensaje]);

  React.useEffect(() => {
    if (paramIng.modo && paramIng.modo === "1") {
      document.body.style.backgroundColor = "#2f3035";
      setColor({
        main: "#2f3035",
        pText: "white",
        sText: "whitesmoke",
      });
    }
    const p = {
      Sigla: paramIng.sigla,
      Modo: paramIng.modo,
      Token: paramIng.token,
    };
    setParams(p);
    dispatch(GetDiasJefe(p));
  }, []);
  return (
    <React.Fragment>
      <Stack
        sx={{
          p: 0,
          overflowY: "hidden",
          height: "100vh",
          maxHeight: "100vh",
        }}
      >
        <Backdrop
          sx={{
            zIndex: theme.zIndex.drawer + 1,
          }}
          open={backdrop}
        >
          <CircularProgress />
        </Backdrop>

        {!backdrop && listado && listado.length === 0 && (
          <Typography
            sx={{
              mt: 4,
              flexGrow: 1,
              display: "flex",
              justifyContent: "center",
            }}
            color="error"
          >
            No hay datos a mostrar.
          </Typography>
        )}
        {!backdrop && listado && listado.length > 0 && (
          <Stack
            sx={{
              overflow: "auto",
              height: "calc(100vh - 32px)",
              mt: 2,
            }}
          >
            <Stack spacing={2} padding={2}>
              {listado
                .sort((a, b) => {
                  return a.Desde > b.Desde
                    ? sort
                    : a.Desde < b.Desde
                      ? -1 * sort
                      : 0;
                })
                .map((item) => (
                  <SwiperCard
                    enabled={item.Estado === 0}
                    card={
                      <Accordion
                        disabled={
                          !item.Motivo &&
                          (!item.Historico || item.Historico.length === 0) &&
                          (!item.Dias || item.Dias.length === 0)
                        }
                        sx={{
                          backgroundColor: color.main,
                          border: "1px solid " + color.sText,
                        }}
                      >
                        <AccordionSummary variant="outlined">
                          <Stack direction="row" sx={{ width: "100%" }}>
                            <Icon
                              sx={{
                                ml: 0.5,
                                mr: 2,
                                color: color.sText,
                              }}
                              fontSize="large"
                            >
                              date_range
                            </Icon>

                            <Stack sx={{ width: "100%" }}>
                              <Stack direction="row">
                                <Typography
                                  variant="caption"
                                  sx={{ color: color.pText, flexGrow: 1 }}
                                >
                                  {DateFormat(
                                    new Date(item.Desde),
                                    "dd/MM/yyyy HH:00",
                                  )}
                                </Typography>
                                <Typography
                                  variant="caption"
                                  sx={{ color: color.sText }}
                                >
                                  {item.Dias.length +
                                    " día" +
                                    (item.Dias.length > 1 ? "s" : "")}
                                </Typography>
                              </Stack>
                              <Typography
                                variant="caption"
                                fontWeight="bold"
                                sx={{ lineBreak: "nowrap", color: color.pText }}
                              >
                                {item.NombreConductor}
                              </Typography>
                            </Stack>
                          </Stack>
                        </AccordionSummary>
                        <AccordionDetails>
                          {item.Motivo && (
                            <Typography
                              variant="caption"
                              sx={{ color: color.sText }}
                            >
                              {item.Motivo}
                            </Typography>
                          )}
                          {item.Dias && item.Dias.length > 0 && (
                            <Stack direction="row" spacing={0.5}>
                              <Typography
                                variant="caption"
                                fontWeight="bold"
                                sx={{ color: color.sText }}
                              >
                                Días:
                              </Typography>
                              <Stack>
                                {item.Dias.map((d) => (
                                  <Typography
                                    variant="caption"
                                    sx={{ color: color.sText }}
                                  >
                                    {DateFormat(
                                      new Date(d.Fecha),
                                      "dd/MM/yyyy",
                                    ) +
                                      " - " +
                                      d.Texto}
                                  </Typography>
                                ))}
                              </Stack>
                            </Stack>
                          )}

                          {item.Historico && item.Historico.length > 0 && (
                            <Stack direction="row" spacing={0.5} margin={0}>
                              <Typography
                                variant="caption"
                                fontWeight="bold"
                                sx={{ color: color.sText }}
                              >
                                Últimas solicitudes:
                              </Typography>
                              <Stack>
                                {item.Historico.map((h) => (
                                  <Typography
                                    variant="caption"
                                    sx={{
                                      color:
                                        h.Estado === 1
                                          ? "green"
                                          : h.Estado === 2
                                            ? "red"
                                            : color.sText,
                                    }}
                                  >
                                    {DateFormat(
                                      new Date(h.Desde),
                                      "dd/MM/yyyy HH:00",
                                    ) +
                                      " - " +
                                      h.Cantidad +
                                      " - " +
                                      (h.Estado === 1
                                        ? "Aprobada"
                                        : h.Estado === 2
                                          ? "Rechazada"
                                          : "Pendiente")}
                                  </Typography>
                                ))}
                              </Stack>
                            </Stack>
                          )}
                        </AccordionDetails>
                      </Accordion>
                    }
                    wrapperStart={
                      <Stack height="100%" sx={{ backgroundColor: "green" }}>
                        <Button
                          variant="contained"
                          onClick={() => {
                            setDia(item);
                            setAprobar("aprobar");
                          }}
                          size="small"
                          sx={{
                            backgroundColor: "green",
                            height: "100%",
                          }}
                        >
                          Aprobar
                        </Button>
                      </Stack>
                    }
                    wrapperEnd={
                      <Stack height="100%" sx={{ backgroundColor: "red" }}>
                        <Button
                          sx={{ backgroundColor: "red", height: "100%" }}
                          variant="contained"
                          size="small"
                          onClick={() => {
                            setDia(item);
                            setAprobar("rechazar");
                          }}
                        >
                          Rechazar
                        </Button>
                      </Stack>
                    }
                  />
                ))}
            </Stack>
          </Stack>
        )}
        <Grid
          container
          sx={{
            position: "absolute",
            bottom: 0,
            right: 0,
            zIndex: 1002,
            margin: "5px",
          }}
          spacing={1}
        >
          {!backdrop && listado && listado.length > 0 && (
            <Grid size={12} sx={{ justifyContent: "end", display: "flex" }}>
              <Fab
                size="small"
                color="primary"
                // sx={{ borderRadius: "15px" }}
                onClick={() => setSort(sort * -1)}
              >
                <Icon>import_export</Icon>
              </Fab>
            </Grid>
          )}
          <Grid
            size={12}
            sx={{ justifyContent: "end", display: "flex", height: "40px" }}
          ></Grid>
        </Grid>
      </Stack>
      <Consulta
        open={Boolean(dia) || false}
        ar={aprobar}
        onClose={() => {
          setDia(null);
          setAprobar("");
        }}
        onSave={() => {
          aprobar &&
            dispatch(
              AprobarRechazar({
                Aprobar: aprobar,
                Sigla: params.Sigla,
                Token: params.Token,
                Id: dia.Id,
                IdConductor: dia.IdConductor,
              }),
            );
          setDia(null);
          setAprobar("");
        }}
        datos={dia}
      />
    </React.Fragment>
  );
};

export default DiasJefe;
